import { PageTitle } from '@/components/seo/page-title';
import { TasteProfileScreen } from '@/screens/settings/taste-profile-screen';
import React from 'react';

export default function TasteProfileRoute() {
  return (
    <>
      <PageTitle title="Taste Profile" />
      <TasteProfileScreen />
    </>
  );
}
